import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/politica-de-privacidad',
    element: <PrivacyPage />,
  },
  {
    path: '/politica-de-cookies',
    element: <CookiesPage />,
  },
  {
    path: '/aviso-legal',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
